import { render, staticRenderFns } from "./PanSearchPage.vue?vue&type=template&id=2fe31959&scoped=true"
import script from "./PanSearchPage.vue?vue&type=script&lang=js"
export * from "./PanSearchPage.vue?vue&type=script&lang=js"
import style0 from "./PanSearchPage.vue?vue&type=style&index=0&id=2fe31959&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_bddh7bz47tm4asog4nvkp26dru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe31959",
  null
  
)

export default component.exports